interface Props {
  userName: any;
}

export const CategoryText = ({ userName }: Props) => {
  return (
    <h1 className="mb-4 text-lg font-bold text-white sm:text-xl">
      {userName ? userName : 'Profile Loading'}
    </h1>
  );
};
